module.exports = __webpack_public_path__ + "img/UserInterests.40c0e040.svg";